import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { Angulartics2Module } from 'angulartics2';

import {
  FormValidationModule,
  TabsModule,
  UtilsModule,
  SwitcherModule,
} from '@tablesready/common-ui';
import { ButtonGroupControlModule } from '@tablesready/button-group-control';
import { CanvasModule } from '@tablesready/canvas';
import { ResourcesComponent } from './resources.component';
import { AddEditResourceComponent } from './modals/add-edit-resource/add-edit-resource.component';
import {
  ResourcesListComponent,
  ResourcesPageComponent,
  FloorplanBuilderModule,
} from './components';
import { ResourcesRoutingModule } from './resources.routing.module';
import { IonicModule } from '@ionic/angular';
import { FrontendIconsModule } from '@tablesready/frontend-icons';
import { AuthModule } from '@tablesready/frontend-auth';
import { AlertsModule } from '@tablesready/frontend-alerts-bar';
import { FrontendDropdownModule } from '@tablesready/frontend-dropdown';
import { FrontendModalModule } from '@tablesready/frontend-modal';
import { ResourcesPageService } from './rosources-page.service';
import { FrontendPullRefreshModule } from '@tablesready/frontend-pull-refresh';

@NgModule({
  declarations: [
    ResourcesComponent,
    AddEditResourceComponent,
    ResourcesListComponent,
    ResourcesPageComponent,
  ],
  imports: [
    FloorplanBuilderModule,
    FrontendIconsModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    AuthModule,
    AlertsModule,
    FormValidationModule,
    NgbModule,
    NgSelectModule,
    Angulartics2Module,
    ResourcesRoutingModule,
    TabsModule,
    CanvasModule,
    ButtonGroupControlModule,
    UtilsModule,
    SwitcherModule,
    IonicModule,
    FrontendDropdownModule,
    FrontendModalModule,
    FrontendPullRefreshModule,
  ],
  providers: [ResourcesPageService],
})
export class ResourcesModule {}
